// import { useState, useEffect } from "react";
// import { images } from "../constants/images";
// import { PORTFOLIOS } from "../constants/portfolioData";
// import ClientCard from "../components/ClientCard";
// import "../assets/stylesheets/bootstrap.min.css";
// import "../assets/stylesheets/style.css";
// import "../assets/stylesheets/responsive.css";
// import bg0 from "../assets/images/leadMagnet/bg0.svg";
// import auditReportPdf from "../assets/audit_report_1.pdf";
// import { useModal } from "../context/ModalContext";
// import SoftwareBanner from "../components/SoftwareBanner";
// import SoftwareAuditModal from "../components/SoftwareAuditModal";

// const ThingsYouWillGetInThisReport = ({ openModal }) => {
//   return (
//     <section
//       className="d-flex align-items-center justify-content-center min-vauto"
//       style={{
//         backgroundImage: `url(${bg0})`,
//         backgroundPosition: "center",
//         backgroundSize: "cover",
//         backgroundRepeat: "no-repeat",
//         padding: "45px",
//       }}
//     >
//       <div className="container mt-1">
//         <div className="row justify-content-center mt-5">
//           <div className="col-lg-12">
//             <h2 className="tc-primary head-font fs-44 text-center">
//               Planning to build software?
//             </h2>
//             <p
//               className="head-font2 tc-primary fs-20 mb-2 mt-2"
//               style={{ textAlign: "center" }}
//             >
//               Don’t start blind. Get a Free Software Audit Report — and know
//               exactly what to build, which features to prioritise, and how much
//               it should really cost.
//             </p>

//             <p className="head-font2 black fs-17 mb-2 mt-2 text-center">
//               It’s like having a tech advisor — but free.
//             </p>

//             <p className="head-font2 tc-primary fs-20 mb-2 mt-2 text-center">
//               We’ll help you figure out:
//             </p>

//             <ul
//               className="text-center"
//               style={{
//                 listStyle: "none",
//                 fontFamily: "Inter",
//                 fontStyle: "normal",
//                 fontWeight: 400,
//                 fontSize: "24px",
//                 lineHeight: "36px",
//                 color: "#000000",
//               }}
//             >
//               <li style={{ fontSize: 20 }}>
//                 👉 What exactly to build (and why)
//               </li>
//               <li style={{ fontSize: 20 }}>👉 Which features really matter</li>
//               <li style={{ fontSize: 20 }}>
//                 👉 Tech stack, timeline & cost estimates
//               </li>
//               <li style={{ fontSize: 20 }}>
//                 👉 And how to avoid wasting lakhs on the wrong development
//               </li>
//             </ul>

//             <br />
//             <div className="text-center">
//               <button
//                 onClick={() => {
//                   window.open("/lm/software-audit", "_blank");
//                 }}
//                 className="LM_link_btn"
//               >
//                 👉 Claim My Free Audit Report
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };
// export default function Home() {
//   const { showModal, handleClose } = useModal();
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const openModal = () => setIsModalOpen(true);

//   useEffect(() => {
//     document.title = "Home - Plural Code Technologies";
//   }, []);
//   return (
//     <div>
//       <main className="wrapper">
//         {/* <WhoWeOfferBanner/> */}
//         <SoftwareBanner />
//         <section className="sec-03 th-bg-secondary-light bg-right">
//           <div className="container">
//             <div className="row align-items-center">
//               <div className="col-lg-6">
//                 <img
//                   src={images?.aboutUs}
//                   className="brr-15 img-fluid h-450"
//                   alt=""
//                 />
//               </div>
//               <div className="col-lg-6 ps-lg-5">
//                 <div className="ps-0 px-md-3 pe-0 pt-4 pt-lg-0 ps-lg-5">
//                   <p className="tc-primary para-font fs-17 fw-500 mb-2 mt-2">
//                     WE REALLY LOVE WHAT WE DO
//                   </p>
//                   <h2
//                     className="tc-primary head-font fs-44"
//                     style={{ textAlign: "justify" }}
//                   >
//                     while always trying to get the job done!
//                   </h2>
//                   <div className="pt-2">
//                     <hr className="mb-3" />
//                   </div>
//                   <p
//                     className="head-font2 tc-primary fs-17"
//                     style={{ textAlign: "justify" }}
//                   >
//                     Partner with us to develop we-applications that stand out
//                   </p>
//                   <ul className="head-font2">
//                     <li>
//                       <a className="fs-17" style={{ textAlign: "justify" }}>
//                         Plural Code Technologies (part of{" "}
//                         <b>Sarentu IT Solutions Pvt. Ltd.</b>), based in New
//                         Delhi and serving clients globally since December 2015,
//                         is a dynamic software development firm dedicated to
//                         simplifying web and mobile development.
//                       </a>
//                     </li>
//                     <li>
//                       <a className="fs-17" style={{ textAlign: "justify" }}>
//                         With extensive expertise in software engineering, we
//                         deliver professional, streamlined processes to our
//                         clients.
//                       </a>
//                     </li>
//                     <li>
//                       <a className="fs-17" style={{ textAlign: "justify" }}>
//                         Our portfolio showcases projects of varying scales,
//                         highlighting our adaptability and proficiency across a
//                         wide array of technologies, including Ruby on Rails,
//                         Python, Django, React Native, React JS, Flutter, and
//                         more.
//                       </a>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>

//         <section className="page-hero-sec">
//           <div className="container text-center">
//             <h2
//               className="tc-primary head-font fs-44 pb-5"
//               style={{ textAlign: "center" }}
//             >
//               Our core technologies
//             </h2>
//           </div>
//         </section>

//         <div
//           className="row justify-content-center pb-50"
//           style={{
//             marginTop: 50,
//             margin: "0 auto",
//             background: "#333333",
//           }}
//         >
//           <div
//             className="col-lg-2 col-md-6"
//             style={{ justifyContent: "center", display: "flex" }}
//           >
//             <img
//               src={images?.rorTechnology}
//               style={{
//                 height: 200,
//                 width: 125,
//               }}
//               className="technology-fluid"
//               alt=""
//             />
//           </div>

//           <div
//             className="col-lg-2 col-md-6"
//             style={{ justifyContent: "center", display: "flex" }}
//           >
//             <img
//               src={images?.pyhton}
//               style={{
//                 height: 200,
//                 width: 70,
//               }}
//               className="technology-fluid"
//               alt=""
//             />
//           </div>

//           <div
//             className="col-lg-2 col-md-6"
//             style={{ justifyContent: "center", display: "flex" }}
//           >
//             <img
//               src={images?.django}
//               style={{
//                 height: 200,
//                 width: 90,
//               }}
//               className="technology-fluid"
//               alt=""
//             />
//           </div>

//           <div
//             className="col-lg-2 col-md-6"
//             style={{ justifyContent: "center", display: "flex" }}
//           >
//             <img
//               src={images?.mlTechnology}
//               style={{
//                 height: 200,
//                 width: 90,
//               }}
//               className="technology-fluid"
//               alt=""
//             />
//           </div>

//           <div
//             className="col-lg-2 col-md-6"
//             style={{ justifyContent: "center", display: "flex" }}
//           >
//             <img
//               src={images?.reactTechnology}
//               style={{
//                 height: 200,
//                 width: 225,
//               }}
//               className="technology-fluid"
//               alt=""
//             />
//           </div>

//           <div
//             className="col-lg-2 col-md-6"
//             style={{ justifyContent: "center", display: "flex" }}
//           >
//             <img
//               src={images?.reactnativeTechnology}
//               style={{
//                 height: 200,
//                 width: 225,
//               }}
//               className="technology-fluid"
//               alt=""
//             />
//           </div>
//         </div>

//         <div
//           className="row justify-content-center pb-50"
//           style={{
//             marginTop: 50,
//             width: "75%",
//             margin: "0 auto",
//             backgroundImage: `url(../assets/images/ror-logo.png)`,
//             borderRadius: 15,
//             background: "#0a2458",
//           }}
//         ></div>

//         <ThingsYouWillGetInThisReport openModal={openModal} />

//         <section className="page-hero-sec pb-5">
//           <div
//             className="container text-center"
//             style={{
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             <h2
//               className="tc-primary head-font fs-44"
//               style={{ textAlign: "center" }}
//             >
//               Why we're the best fit for you
//             </h2>
//           </div>
//         </section>

//         <div
//           className="row pb-4"
//           style={{
//             marginTop: 75,
//             width: "75%",
//             margin: "0 auto",
//           }}
//         >
//           <div className="col-lg-4">
//             <div className="d-flex text-center flex-column align-items-center justify-content-center pb-4">
//               <p
//                 className="tc-primary para-font fs-20 fw-500 mb-2 mt-2"
//                 style={{ textAlign: "right" }}
//               >
//                 <strong>Premium Solutions</strong>
//               </p>
//               <p
//                 className="head-font2 tc-primary fs-17 mb-2 mt-2"
//                 style={{ textAlign: "justify" }}
//               >
//                 Our seasoned development team prioritizes quality above all
//                 else, ensuring top-notch results every time.
//               </p>
//             </div>
//           </div>
//           <div className="col-lg-4">
//             <div className="d-flex text-center flex-column align-items-center justify-content-center pb-4">
//               <p className="tc-primary para-font fs-20 fw-500 mb-2 mt-2">
//                 <strong>Expert Consultation</strong>
//               </p>
//               <p
//                 className="head-font2 tc-primary fs-17 mb-2 mt-2"
//                 style={{ textAlign: "justify" }}
//               >
//                 Beyond development, we offer consultancy services to guide you
//                 in crafting the finest possible app.
//               </p>
//             </div>
//           </div>
//           <div className="col-lg-4">
//             <div className="d-flex text-center flex-column align-items-center justify-content-center pb-4">
//               <p className="tc-primary para-font fs-20 fw-500 mb-2 mt-2">
//                 <strong>Effortless Communication</strong>
//               </p>
//               <p
//                 className="head-font2 tc-primary fs-17 mb-2 mt-2"
//                 style={{ textAlign: "justify" }}
//               >
//                 We recognize the need and role of effective communication, and
//                 we make it a point to provide unwavering support across all time
//                 zones.
//               </p>
//             </div>
//           </div>
//         </div>

//         <div
//           className="row"
//           style={{
//             width: "75%",
//             margin: "0 auto",
//             justifyContent: "center",
//           }}
//         >
//           <div className="col-lg-4">
//             <div className="d-flex text-center flex-column align-items-center justify-content-center pb-4">
//               <p className="tc-primary para-font fs-20 fw-500 mb-2 mt-2">
//                 <strong>Adaptability</strong>
//               </p>
//               <p
//                 className="head-font2 tc-primary fs-17 mb-2 mt-2"
//                 style={{ textAlign: "justify" }}
//               >
//                 Embracing change is what we do the best; we remain flexible
//                 throughout development while adhering to strict timelines.
//               </p>
//             </div>
//           </div>
//           <div className="col-lg-4">
//             <div className="d-flex text-center flex-column align-items-center justify-content-center pb-4">
//               <p className="tc-primary para-font fs-20 fw-500 mb-2 mt-2">
//                 <strong>Goal-Oriented Approach</strong>
//               </p>
//               <p
//                 className="head-font2 tc-primary fs-17 mb-2 mt-2"
//                 style={{ textAlign: "justify" }}
//               >
//                 Your business objectives are our compass; we dedicate ourselves
//                 to helping you achieve them.
//               </p>
//             </div>
//           </div>
//           <div className="col-lg-4">
//             <div className="d-flex text-center flex-column align-items-center justify-content-center pb-4">
//               <p className="tc-primary para-font head-font fs-20 fw-500 mb-2 mt-2">
//                 <strong>Transparency</strong>
//               </p>
//               <p
//                 className="head-font2 tc-primary fs-17 mb-2 mt-2"
//                 style={{ textAlign: "justify" }}
//               >
//                 Trust is what we believe is the fundamental to business success,
//                 which is why we uphold complete transparency in all our
//                 dealings.
//               </p>
//             </div>
//           </div>
//         </div>

//         <section className="sec-03 th-bg-secondary-light bg-left">
//           <div className="container">
//             <div className="row align-items-center">
//               <div className="col-lg-6 order-2 order-lg-1 pe-0 pe-lg-5">
//                 <div className="ps-0 px-md-3 pe-0 pt-4 pt-lg-0 pe-lg-5">
//                   <p className="tc-primary para-font fs-17 fw-500 mb-2 mt-2">
//                     WHAT MATTERS
//                   </p>
//                   <h2 className="tc-primary head-font fs-44">Values</h2>
//                   <div className="pt-2">
//                     <hr className="mb-3" />
//                   </div>
//                   <p
//                     className="head-font2 tc-primary fs-17"
//                     style={{ textAlign: "justify" }}
//                   >
//                     We have created a set of core values during all those years
//                     on the market (and even before). Those define our culture
//                     and affect our everyday work, team relations, and
//                     cooperation with our clients. We believe in making a
//                     commitment to responsibilities, and being accountable for
//                     results.
//                   </p>
//                   <ul className="head-font2">
//                     <li>
//                       <a className="fs-17">Wide array of framework options</a>
//                     </li>
//                     <li>
//                       <a className="fs-17">
//                         Expert consultation through-out the development phase
//                       </a>
//                     </li>
//                     <li>
//                       <a className="fs-17">24/7 support and assistance</a>
//                     </li>
//                     <li>
//                       <a className="fs-17">Transparent functioning</a>
//                     </li>
//                   </ul>
//                 </div>
//               </div>
//               <div className="col-lg-6 order-1 order-lg-2">
//                 <img
//                   src={images?.values}
//                   className="brr-15 img-fluid h-450"
//                   alt=""
//                 />
//               </div>
//             </div>
//           </div>
//         </section>

//         <section
//           className="page-hero-sec"
//           style={{
//             marginBottom: 75,
//           }}
//         >
//           <div
//             className="container text-center"
//             style={{
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             <h2
//               className="tc-primary head-font fs-44"
//               style={{ textAlign: "center" }}
//             >
//               OUR CLIENTS
//             </h2>
//             <p className="tc-primary para-font fs-17 fw-500 mb-2 mt-2">
//               ALL OF THEM ARE SATISFIED
//             </p>
//           </div>
//         </section>

//         <div
//           className="row pb-4"
//           style={{
//             marginTop: 75,
//             width: "75%",
//             margin: "0 auto",
//           }}
//         >
//           {PORTFOLIOS.slice(0, 8).map((item) => {
//             return (
//               item?.forHomePage && <ClientCard item={item} key={item.name} />
//             );
//           })}
//         </div>

//         <div
//           className="row"
//           style={{
//             width: "75%",
//             margin: "0 auto",
//             justifyContent: "center",
//           }}
//         >
//           {PORTFOLIOS.slice(8, 23).map((item) => {
//             return (
//               item?.forHomePage && <ClientCard item={item} key={item.name} />
//             );
//           })}
//         </div>
//       </main>

//       {showModal && (
//         <SoftwareAuditModal handleClose={handleClose} showModal={showModal} />
//       )}
//     </div>
//   );
// }

import { useState, useEffect } from "react";
import { images } from "../constants/images";
import { PORTFOLIOS } from "../constants/portfolioData";
import ClientCard from "../components/ClientCard";
import "../assets/stylesheets/bootstrap.min.css";
import "../assets/stylesheets/style.css";
import "../assets/stylesheets/responsive.css";
import bg0 from "../assets/images/leadMagnet/bg0.svg";
import { useModal } from "../context/ModalContext";
// import SoftwareAuditModal from "../components/SoftwareAuditModal";
import blueBack from "../assets/images/leadMagnet/blue-back.png";

const HeroSection = () => (
  <section
    style={{
      minHeight: "90vh",
      display: "flex",
      alignItems: "center",
      position: "relative",
      overflow: "hidden",
      background:
        "linear-gradient(135deg, #0a2458 0%, #1a3b8a 30%, #2a4ba8 70%, #3a5dc8 100%)",
    }}
  >
    {/* Background Elements */}
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `
        radial-gradient(circle at 20% 80%, rgba(255, 215, 0, 0.15) 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
        radial-gradient(circle at 40% 40%, rgba(10, 36, 88, 0.2) 0%, transparent 50%)
      `,
      }}
    />

    {/* Floating Elements */}
    <div
      style={{
        position: "absolute",
        top: "20%",
        left: "5%",
        width: "100px",
        height: "100px",
        borderRadius: "50%",
        background: "rgba(255, 215, 0, 0.1)",
        filter: "blur(20px)",
        animation: "float 20s infinite linear",
      }}
    />

    <div
      style={{
        position: "absolute",
        bottom: "20%",
        right: "10%",
        width: "150px",
        height: "150px",
        borderRadius: "50%",
        background: "rgba(255, 255, 255, 0.05)",
        filter: "blur(30px)",
        animation: "float 25s infinite linear reverse",
      }}
    />

    <div className="container" style={{ paddingTop: "80px" }}>
      <div className="row align-items-center min-vh-90">
        <div className="col-lg-6 col-md-12 mb-5 mb-lg-0">
          <div className="text-white position-relative" style={{ zIndex: 2 }}>
            {/* Badge */}
            <div
              className="d-inline-flex align-items-center gap-2 px-3 py-2 rounded-pill mb-4"
              style={{
                background: "rgba(255, 215, 0, 0.15)",
                backdropFilter: "blur(10px)",
                border: "1px solid rgba(255, 215, 0, 0.3)",
              }}
            >
              <span style={{ fontSize: "20px" }}>🚀</span>
              <span
                className="fw-bold"
                style={{ fontSize: "14px", color: "#FFD700" }}
              >
                TRUSTED BY 500+ BUSINESSES
              </span>
            </div>

            {/* Main Heading */}
            <h1
              className="display-3 fw-bold mb-4"
              style={{
                lineHeight: "1.1",
                background:
                  "linear-gradient(to right, #FFFFFF 0%, #E6F0FF 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                textShadow: "0 2px 10px rgba(0,0,0,0.1)",
              }}
            >
              Custom Business Software Built Around{" "}
              <span
                className="d-inline-block"
                style={{
                  background:
                    "linear-gradient(90deg, #FFD700 0%, #FFEC8B 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  backgroundClip: "text",
                  position: "relative",
                  padding: "0 5px",
                }}
              >
                YOUR
              </span>{" "}
              Workflow
            </h1>

            {/* Subtitle */}
            <p
              className="fs-5 mb-5"
              style={{
                color: "#E6F0FF",
                lineHeight: "1.6",
                maxWidth: "90%",
                fontWeight: "300",
              }}
            >
              Stop forcing your business into off-the-shelf software. <br /> We
              build solutions that fit your unique processes perfectly <br />
              boosting efficiency by up to 68%.
            </p>

            {/* CTA Buttons */}
            <div className="d-flex flex-wrap gap-3 mb-5">
              <button
                onClick={() =>
                  window.open("lm/custom-software-roi-calculator", "_blank")
                }
                className="btn btn-lg px-5 py-3 d-flex align-items-center gap-2"
                style={{
                  background:
                    "linear-gradient(135deg, #FFD700 0%, #FFC107 100%)",
                  border: "none",
                  color: "#0a2458",
                  fontWeight: "700",
                  borderRadius: "12px",
                  transition: "all 0.3s ease",
                  boxShadow: "0 10px 30px rgba(255, 215, 0, 0.3)",
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "translateY(-3px)";
                  e.target.style.boxShadow =
                    "0 15px 40px rgba(255, 215, 0, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow =
                    "0 10px 30px rgba(255, 215, 0, 0.3)";
                }}
              >
                <span>📊</span>
                <span>Calculate Your Custom Software ROI</span>
              </button>

              <button
                onClick={() => {
                  document
                    .getElementById("how-we-work")
                    ?.scrollIntoView({ behavior: "smooth" });
                }}
                className="btn btn-lg px-5 py-3 d-flex align-items-center gap-2"
                style={{
                  background: "transparent",
                  border: "2px solid #FFD700",
                  color: "#FFD700",
                  fontWeight: "600",
                  borderRadius: "12px",
                  transition: "all 0.3s ease",
                  backdropFilter: "blur(10px)",
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = "rgba(255, 215, 0, 0.1)";
                  e.target.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "transparent";
                  e.target.style.transform = "translateY(0)";
                }}
              >
                <span>▶️</span>
                <span>See How We Work</span>
              </button>
            </div>

            {/* Trust Indicators */}
            <div className="d-flex flex-wrap align-items-center gap-4">
              {/* Client Avatars */}

              {/* Trust Text */}
              <div className="d-flex flex-column">
                <div className="d-flex align-items-center gap-2 mb-1">
                  <span style={{ color: "#FFD700", fontSize: "20px" }}>⭐</span>
                  <span style={{ color: "#FFFFFF", fontWeight: "600" }}>
                    4.9/5 Rating
                  </span>
                </div>
                <p
                  className="mb-0"
                  style={{ color: "#E6F0FF", fontSize: "14px" }}
                >
                  Trusted by businesses across 20+ industries worldwide
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Hero Image */}
        <div className="col-lg-6 col-md-12">
          <div className="position-relative">
            {/* Main Image Container */}
            <div
              style={{
                position: "relative",
                padding: "20px",
              }}
            >
              {/* Floating Background Shape */}
              <div
                style={{
                  position: "absolute",
                  top: "0",
                  right: "0",
                  bottom: "0",
                  left: "0",
                  background:
                    "linear-gradient(135deg, rgba(255,215,0,0.15) 0%, rgba(255,215,0,0) 50%)",
                  borderRadius: "25px",
                  transform: "rotate(5deg)",
                  zIndex: 0,
                }}
              />

              {/* Image Container */}
              <div
                style={{
                  position: "relative",
                  borderRadius: "20px",
                  overflow: "hidden",
                  boxShadow: "0 25px 50px rgba(0,0,0,0.4)",
                  transform: "perspective(1000px) rotateY(-5deg) rotateX(2deg)",
                  transition: "transform 0.5s ease",
                  zIndex: 1,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform =
                    "perspective(1000px) rotateY(0deg) rotateX(0deg)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform =
                    "perspective(1000px) rotateY(-5deg) rotateX(2deg)";
                }}
              >
                <img
                  src={images?.customBusinessSoftware}
                  className="img-fluid w-100"
                  alt="Custom Software Development Dashboard"
                  style={{
                    display: "block",
                    height: "auto",
                    objectFit: "cover",
                  }}
                />

                {/* Image Overlay Effect */}
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background:
                      "linear-gradient(to bottom, transparent 0%, rgba(10, 36, 88, 0.3) 100%)",
                    pointerEvents: "none",
                  }}
                />
              </div>
            </div>

            {/* Floating Stats Cards */}
            <div
              style={{
                position: "absolute",
                bottom: "-30px",
                left: "-20px",
                background: "rgba(255, 255, 255, 0.95)",
                backdropFilter: "blur(10px)",
                padding: "20px",
                borderRadius: "15px",
                boxShadow: "0 15px 35px rgba(0,0,0,0.2)",
                width: "250px",
                zIndex: 2,
              }}
            >
              <div className="d-flex align-items-center gap-3">
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "12px",
                    background:
                      "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontSize: "24px",
                  }}
                >
                  ⚡
                </div>
                <div>
                  <div className="fw-bold fs-4" style={{ color: "#0a2458" }}>
                    68%
                  </div>
                  <div className="fs-12" style={{ color: "#0A2458" }}>
                    Average Efficiency Gain
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                position: "absolute",
                top: "-20px",
                right: "-10px",
                background: "rgba(255, 215, 0, 0.95)",
                backdropFilter: "blur(10px)",
                padding: "15px",
                borderRadius: "15px",
                boxShadow: "0 15px 35px rgba(255, 215, 0, 0.3)",
                width: "200px",
                zIndex: 2,
              }}
            >
              <div className="text-center">
                <div className="fw-bold fs-4" style={{ color: "#0a2458" }}>
                  8 Months
                </div>
                <div className="fs-12" style={{ color: "#0a2458" }}>
                  Average ROI Time
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Scroll Indicator */}
    <div
      style={{
        position: "absolute",
        bottom: "40px",
        left: "50%",
        transform: "translateX(-50%)",
        animation: "bounce 2s infinite",
      }}
    >
      <button
        onClick={() => {
          document
            .getElementById("how-we-work")
            ?.scrollIntoView({ behavior: "smooth" });
        }}
        style={{
          background: "transparent",
          border: "none",
          color: "#FFD700",
          fontSize: "24px",
          cursor: "pointer",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <div style={{ transform: "rotate(90deg)", fontSize: "20px" }}></div>
        <div style={{ fontSize: "12px", letterSpacing: "2px" }}>SCROLL</div>
      </button>
    </div>

    <style jsx>{`
      @keyframes float {
        0% {
          transform: translate(0, 0) rotate(0deg);
        }
        25% {
          transform: translate(10px, -10px) rotate(90deg);
        }
        50% {
          transform: translate(20px, 10px) rotate(180deg);
        }
        75% {
          transform: translate(-10px, 20px) rotate(270deg);
        }
        100% {
          transform: translate(0, 0) rotate(360deg);
        }
      }

      @keyframes bounce {
        0%,
        20%,
        50%,
        80%,
        100% {
          transform: translateY(0) translateX(-50%);
        }
        40% {
          transform: translateY(-10px) translateX(-50%);
        }
        60% {
          transform: translateY(-5px) translateX(-50%);
        }
      }

      .min-vh-90 {
        min-height: 90vh;
      }

      .fs-12 {
        font-size: 12px;
      }

      @media (max-width: 768px) {
        .display-3 {
          font-size: 2.5rem !important;
        }

        .min-vh-90 {
          min-height: auto;
          padding: 80px 0;
        }
      }
    `}</style>
  </section>
);

// THE PROBLEM SECTION
const ProblemSection = () => {
  const problems = [
    {
      icon: "🔄",
      title: "Workflow Mismatch",
      description:
        "You're forced to change how you work to fit the software, not the other way around",
    },
    {
      icon: "📦",
      title: "Feature Overload",
      description:
        "You pay for hundreds of features you'll never use while missing the ones you actually need",
    },
    {
      icon: "🔗",
      title: "Integration Nightmares",
      description:
        "Connecting multiple systems creates data silos and manual workarounds",
    },
    {
      icon: "📈",
      title: "Scalability Issues",
      description:
        "As your business grows, the software can't adapt to your evolving processes",
    },
    {
      icon: "🔒",
      title: "Vendor Lock-in",
      description:
        "You're stuck with their update schedule, their priorities, their limitations",
    },
  ];

  return (
    <section
      className="sec-02"
      style={{
        padding: "100px 0",
        background: "linear-gradient(180deg, #FFFFFF 0%, #F8FAFF 100%)",
      }}
    >
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 mb-5 mb-lg-0">
            <div style={{ position: "relative" }}>
              <br />
              <br />
              <br />
              <img
                src={images?.offShelfSoftwareHoldingBack}
                className="img-fluid rounded-4"
                alt="Off-the-shelf software problems"
                style={{
                  boxShadow: "0 20px 40px rgba(10, 36, 88, 0.1)",
                }}
              />
              <br/>
               <br/>
                <br/>
               <img
                src={images?.Overwhelmed}
                className="img-fluid rounded-4"
                alt="Off-the-shelf software problems"
                style={{
                  boxShadow: "0 20px 40px rgba(10, 36, 88, 0.1)",
                }}
              />
              {/* <div
                style={{
                  position: "absolute",
                  top: "-20px",
                  left: "-20px",
                  width: "80px",
                  height: "80px",
                  background: "#FFD700",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "32px",
                  boxShadow: "0 10px 20px rgba(255, 215, 0, 0.3)",
                }}
              >
                ⚠️
              </div> */}
            </div>
          </div>
          <div className="col-lg-6 ps-lg-5">
            <div className="mb-4">
              <span
                className="px-3 py-1 rounded-pill d-inline-block mb-3"
                style={{
                  background: "rgba(10, 36, 88, 0.1)",
                  color: "#0a2458",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                COMMON PAIN POINTS
              </span>
              <h2
                className="tc-primary head-font mb-4"
                style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)" }}
              >
                Is Off-the-Shelf Software Holding Your Business Back?
              </h2>
              <p
                className="head-font2 tc-primary fs-17 mb-4"
                style={{ color: "#0A2458" }}
              >
                Most businesses struggle with generic software that wasn't built
                for their unique needs:
              </p>
            </div>

            {problems.map((problem, index) => (
              <div
                key={index}
                className="d-flex gap-3 mb-4 p-3 rounded-3"
                style={{
                  background:
                    index % 2 === 0 ? "rgba(10, 36, 88, 0.02)" : "transparent",
                  borderLeft: `3px solid ${
                    index % 2 === 0 ? "#FFD700" : "#0a2458"
                  }`,
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateX(5px)";
                  e.currentTarget.style.background = "rgba(10, 36, 88, 0.05)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateX(0)";
                  e.currentTarget.style.background =
                    index % 2 === 0 ? "rgba(10, 36, 88, 0.02)" : "transparent";
                }}
              >
                <div
                  className="flex-shrink-0"
                  style={{
                    fontSize: "24px",
                    width: "48px",
                    height: "48px",
                    background: "rgba(10, 36, 88, 0.1)",
                    borderRadius: "12px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {problem.icon}
                </div>
                <div>
                  <h3 className="head-font2 tc-primary fs-18 fw-bold mb-2">
                    {problem.title}
                  </h3>
                  <p
                    className="head-font2 tc-primary fs-17 mb-0"
                    style={{ color: "#0A2458" }}
                  >
                    {problem.description}
                  </p>
                </div>
              </div>
            ))}

            <div
              className="p-4 mt-5 rounded-4"
              style={{
                background:
                  "linear-gradient(135deg, rgba(10, 36, 88, 0.05) 0%, rgba(255, 215, 0, 0.05) 100%)",
                border: "1px solid rgba(10, 36, 88, 0.1)",
                position: "relative",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-10px",
                  left: "20px",
                  background: "#0a2458",
                  color: "white",
                  padding: "5px 15px",
                  borderRadius: "20px",
                  fontSize: "12px",
                  fontWeight: "600",
                }}
              >
                CLIENT TESTIMONIAL
              </div>
              <p
                className="head-font2 fs-17 mb-3"
                style={{ fontStyle: "italic", color: "#0A2458" }}
              >
                "We spent months trying to make existing software work for our
                manufacturing process. It never fit. Custom development changed
                everything 40% efficiency gain in 6 months."
              </p>
              <div className="d-flex align-items-center">
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: "#0a2458",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    marginRight: "12px",
                  }}
                >
                  M
                </div>
                <div>
                  <strong
                    className="head-font2 fs-16"
                    style={{ color: "#0a2458" }}
                  >
                    Manufacturing Client
                  </strong>
                  <p
                    className="head-font2 fs-14 mb-0"
                    style={{ color: "#0A2458" }}
                  >
                    Australia • 500+ Employees
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// THE SOLUTION SECTION
const SolutionSection = () => {
  const solutions = [
    {
      icon: "📋",
      title: "Built for Your Workflow",
      description:
        "We map your exact processes and build software that supports them not forces you to change",
    },
    {
      icon: "🎯",
      title: "Only What You Need",
      description:
        "No bloated features. Every function serves your specific business requirements",
    },
    {
      icon: "🔗",
      title: "Seamless Integration",
      description:
        "Connect with your existing tools and systems without friction or data loss",
    },
    {
      icon: "⚡",
      title: "Lightning Fast",
      description:
        "Optimized performance tailored to your specific use cases and data volumes",
    },
    {
      icon: "🛡️",
      title: "Future-Proof",
      description:
        "Built with scalability and adaptability in mind for long-term growth",
    },
    {
      icon: "📊",
      title: "Real-time Insights",
      description:
        "Custom dashboards and reporting that matter to your business decisions",
    },
  ];

  return (
    <section
      className="sec-03"
      style={{ padding: "100px 0", background: "#FFFFFF" }}
    >
      <div className="container">
        <div className="text-center mb-5">
          <span
            className="px-3 py-1 rounded-pill d-inline-block mb-3"
            style={{
              background: "rgba(255, 215, 0, 0.15)",
              color: "#0a2458",
              fontWeight: "600",
              fontSize: "14px",
            }}
          >
            OUR SOLUTION
          </span>
          <h2
            className="tc-primary head-font mb-4"
            style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)" }}
          >
            Extreme Customization: 
            <br/>
            Software That Fits YOUR Business
          </h2>
          <p
            className="head-font2 tc-primary fs-18 mx-auto"
            style={{
              maxWidth: "800px",
              color: "#0A2458",
              lineHeight: "1.6",
            }}
          >
            We don't believe in one-size-fits-all solutions.  Every business has
            unique workflows, <br/> challenges, and  goals. That's why we build{" "}
            <strong>custom business software from the  <br/> ground   up  </strong>
           
            designed specifically for how YOU work.
          </p>
        </div>

        <div className="row g-4">
          {solutions.map((solution, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div
                className="h-100 p-4 rounded-4"
                style={{
                  background: "white",
                  border: "1px solid rgba(10, 36, 88, 0.1)",
                  boxShadow: "0 4px 6px rgba(10, 36, 88, 0.05)",
                  transition: "all 0.3s ease",
                  position: "relative",
                  overflow: "hidden",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 12px 24px rgba(10, 36, 88, 0.1)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 4px 6px rgba(10, 36, 88, 0.05)";
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    right: "0",
                    height: "4px",
                    background:
                      "linear-gradient(90deg, #0a2458 0%, #1a3b8a 50%, #FFD700 100%)",
                  }}
                />
                <div
                  className="mb-4 rounded-3 d-inline-flex align-items-center justify-content-center"
                  style={{
                    fontSize: "40px",
                    width: "70px",
                    height: "70px",
                    background: "rgba(10, 36, 88, 0.05)",
                  }}
                >
                  {solution.icon}
                </div>
                <h3 className="tc-primary head-font fs-20 mb-3">
                  {solution.title}
                </h3>
                <p
                  className="head-font2 tc-primary fs-17 mb-0"
                  style={{ color: "#0A2458" }}
                >
                  {solution.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-5">
          <div
            className="d-inline-flex align-items-center gap-3 p-4 rounded-4"
            style={{
              background:
                "linear-gradient(135deg, rgb(10, 36, 88) 0%, rgb(26, 59, 138) 100%)",
            }}
          >
            <div style={{ fontSize: "32px" }}>✨</div>
            <div className="text-start">
              <p
                className="head-font2 tc-primary fs-17 mb-0"
                style={{ color: "#ffd700" }}
              >
                <strong>Average 68% efficiency improvement</strong> reported by
                our clients after switching to custom solutions
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// HOW IT WORKS SECTION
const HowItWorksSection = () => {
  const steps = [
    {
      number: 1,
      title: "Discovery & Mapping",
      description:
        "We deep-dive into your business workflows, pain points, and goals. No assumptions just listening.",
    },
    {
      number: 2,
      title: "Custom Design",
      description:
        "We design a solution tailored to your exact needs. You see workflows and architecture before we code.",
    },
    {
      number: 3,
      title: "Agile Development",
      description:
        "We build in sprints so you can see progress weekly. Feedback is incorporated immediately.",
    },
    {
      number: 4,
      title: "Launch & Support",
      description:
        "Smooth deployment with training. We don't disappear ongoing support ensures your software evolves with you.",
    },
  ];

  return (
    <section
      id="how-we-work"
      className="sec-04"
      style={{
        padding: "100px 0",
        background: "linear-gradient(180deg, #FFFFFF 0%, #F0F7FF 100%)",
      }}
    >
      <div className="container">
        <div className="text-center mb-5">
          <span
            className="px-3 py-1 rounded-pill d-inline-block mb-3"
            style={{
              background: "rgba(10, 36, 88, 0.1)",
              color: "#0a2458",
              fontWeight: "600",
              fontSize: "14px",
            }}
          >
            OUR PROCESS
          </span>
          <h2
            className="tc-primary head-font mb-4"
            style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)" }}
          >
            Our Custom Development Process
          </h2>
          <p
            className="head-font2 tc-primary fs-18"
            style={{ maxWidth: "600px", margin: "0 auto", color: "#0A2458" }}
          >
            A proven 4-step methodology that ensures <br /> your software
            perfectly matches your needs
          </p>
        </div>

        <div className="row g-4 position-relative">
          {/* Connecting line */}
          <div
            className="d-none d-lg-block"
            style={{
              position: "absolute",
              top: "60px",
              left: "12%",
               width: "72%",   // 👈 yahan control karo
              height: "2px",
              background: "linear-gradient(90deg, #0a2458, #1a3b8a, #FFD700)",
              zIndex: 0,
            }}
          />

          {steps.map((step, index) => (
            <div className="col-lg-3 col-md-6" key={index}>
              <div
                className="text-center p-4 h-100 position-relative"
                style={{ zIndex: 1 }}
              >
                <div
                  className="mb-4 mx-auto d-flex align-items-center justify-content-center position-relative"
                  style={{
                    width: "80px",
                    height: "80px",
                    background:
                      "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)",
                    color: "white",
                    borderRadius: "50%",
                    fontSize: "32px",
                    fontWeight: "700",
                    boxShadow: "0 10px 25px rgba(10, 36, 88, 0.2)",
                    border: "4px solid white",
                  }}
                >
                  {step.number}
                </div>
                <h3 className="tc-primary head-font fs-20 mb-3">
                  {step.title}
                </h3>
                <p
                  className="head-font2 tc-primary fs-16 mb-0"
                  style={{ color: "#0A2458" }}
                >
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-5">
          <button
            onClick={() =>
              window.open("https://topmate.io/pluralcode/1677658", "_blank")
            }
            className="btn btn-lg px-5 py-3"
            style={{
              background: "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)",
              border: "none",
              color: "white",
              fontWeight: "600",
              borderRadius: "50px",
              transition: "all 0.3s ease",
              boxShadow: "0 10px 25px rgba(10, 36, 88, 0.2)",
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 15px 30px rgba(10, 36, 88, 0.3)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 10px 25px rgba(10, 36, 88, 0.2)";
            }}
          >
            Start with a Free Process Audit
          </button>
          <p
            className="head-font2 tc-primary fs-14 mt-3"
            style={{ color: "#0A2458" }}
          >
            No commitment • 60-minute session • Actionable insights
          </p>
        </div>
      </div>
    </section>
  );
};

// PROOF/CASE STUDY SECTION
const ProofSection = () => {
  return (
    <section
      className="sec-05"
      style={{ padding: "100px 0", background: "#FFFFFF" }}
    >
      <div className="container">
        <div className="text-center mb-5">
          <span
            className="px-3 py-1 rounded-pill d-inline-block mb-3"
            style={{
              background: "rgba(255, 215, 0, 0.15)",
              color: "#0a2458",
              fontWeight: "600",
              fontSize: "14px",
            }}
          >
            CASE STUDY
          </span>
          <h2
            className="tc-primary head-font mb-4"
            style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)" }}
          >
            Real Results: Custom Solutions in Action
          </h2>
        </div>

        <div className="row g-5 align-items-center">
          <div className="col-lg-6">
            <div className="position-relative">
              <img
                src={images?.topimage1}
                className="img-fluid rounded-4"
                alt="Manufacturing Case Study"
                style={{
                  boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                }}
              />
              {/* <div
                className="position-absolute bottom-0 start-0 m-4 p-3 rounded-3"
                style={{
                  background: "rgba(10, 36, 88, 0.95)",
                  backdropFilter: "blur(10px)",
                  color: "white",
                }}
              >



                <div className="d-flex gap-4">
                  <div className="text-center">
                    <div className="fs-24 fw-bold">40%</div>
                    <div className="fs-12">Efficiency Gain</div>
                  </div>
                  <div className="text-center">
                    <div className="fs-24 fw-bold">8</div>
                    <div className="fs-12">Months ROI</div>
                  </div>
                  <div className="text-center">
                    <div className="fs-24 fw-bold">100%</div>
                    <div className="fs-12">Adoption Rate</div>
                  </div>
                </div>
              </div> */}
              <div
  className="position-absolute start-50 translate-middle-x p-3 rounded-3 shadow-lg"
  style={{
    bottom: "-35px",
    background: "rgba(10, 36, 88, 0.95)",
    backdropFilter: "blur(10px)",
    color: "#ffd700",
    minWidth: "80%",
    textAlign: "center",
  }}
>
  <div className="d-flex justify-content-around">
    <div className="text-center">
      <div className="fs-24 fw-bold">40%</div>
      <div className="fs-16">Efficiency Gain</div>
    </div>

    <div className="text-center">
      <div className="fs-24 fw-bold">8</div>
      <div className="fs-16">Months ROI</div>
    </div>

    <div className="text-center">
      <div className="fs-24 fw-bold">100%</div>
      <div className="fs-16">Adoption Rate</div>
    </div>
  </div>
</div>

            </div>
          </div>

          <div className="col-lg-6">
            <div className="p-4">
              <h3 className="tc-primary head-font fs-28 mb-4">
                Manufacturing Process Management System
              </h3>

              <div className="mb-4">
                <div className="d-flex align-items-center gap-2 mb-2">
                  <div
                    style={{
                      width: "8px",
                      height: "8px",
                      background: "#0a2458",
                      borderRadius: "50%",
                    }}
                  ></div>
                  <p className="head-font2 tc-primary fs-18 fw-bold mb-0">
                    The Challenge:
                  </p>
                </div>
                <p
                  className="head-font2 tc-primary fs-16 ps-3"
                  style={{ color: "#0A2458" }}
                >
                  A mid-sized manufacturer was juggling spreadsheets, email
                  chains, and disconnected tools. Off-the-shelf ERP systems were
                  too complex, expensive, and didn't match their workflow.
                </p>
              </div>

              <div className="mb-4">
                <div className="d-flex align-items-center gap-2 mb-2">
                  <div
                    style={{
                      width: "8px",
                      height: "8px",
                      background: "#0a2458",
                      borderRadius: "50%",
                    }}
                  ></div>
                  <p className="head-font2 tc-primary fs-18 fw-bold mb-0">
                    Our Solution:
                  </p>
                </div>
                <p
                  className="head-font2 tc-primary fs-16 ps-3"
                  style={{ color: "#0A2458" }}
                >
                  Custom-built process management software that tracked
                  production, inventory, and quality control designed around
                  their exact workflow with real-time analytics dashboards.
                </p>
              </div>

              <div className="mb-4">
                <div className="d-flex align-items-center gap-2 mb-2">
                  <div
                    style={{
                      width: "8px",
                      height: "8px",
                      background: "#0a2458",
                      borderRadius: "50%",
                    }}
                  ></div>
                  <p className="head-font2 tc-primary fs-18 fw-bold mb-0">
                    The Results:
                  </p>
                </div>
                <div className="ps-3">
                  {[
                    "40% reduction in process delays",
                    "Real-time visibility across all departments",
                    "ROI achieved in 8 months",
                    "System scales as they grow",
                  ].map((result, index) => (
                    <div
                      key={index}
                      className="d-flex align-items-center gap-2 mb-2"
                    >
                      <div style={{ color: "#10B981", fontSize: "20px" }}>
                        ✓
                      </div>
                      <p
                        className="head-font2 tc-primary fs-16 mb-0"
                        style={{ color: "#0A2458" }}
                      >
                        {result}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// LEAD MAGNET SECTION
const LeadMagnetSection = () => {
  const tools = [
    {
      icon: "🧮",
      title: "ROI Calculator",
      description:
        "Calculate the true cost of off-the-shelf vs custom software over 3-5 years",
      link: "/lm/custom-software-roi-calculator",
    },
    {
      icon: "📋",
      title: "Decision Matrix",
      description:
        "Answer 10 questions to see if custom development makes sense for you",
      link: "/decision-matrix",
    },
    {
      icon: "⚖️",
      title: "Cost-Benefit Analyzer",
      description:
        "Compare your current software costs with custom development investment",
      link: "/lm/cost-analyzer",
    },
    {
      icon: "💵",
      title: "Custom Software Total Cost Calculator",
      description:
        "Calculate complete 3-year investment for your custom software project. No hidden surprises!",
      link: "/custom/cost/calculator",
    },
    {
      icon: "📈",
      title: "Custom Software Success Metrics Tracker",
      description:
        "Track ROI, adoption, and performance to measure your software’s success in real time.",
      link: "/custom/metrics/tracker",
    },
    {
      icon: "📊",
      title: "5 Signs You Need Custom Business Software",
      description:
        "See the signs your business needs custom software designed for your workflow.",
      link: "/lm/five-signs-you-need-custom-business-software",
    },
  ];

  return (
    <section
      style={{
        padding: "100px 0",
        background: "linear-gradient(135deg, #F0F7FF 0%, #E6F0FF 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div className="container">
        <div className="text-center mb-5">
          <span
            className="px-3 py-1 rounded-pill d-inline-block mb-3"
            style={{
              background: "rgba(10, 36, 88, 0.1)",
              color: "#0a2458",
              fontWeight: "600",
              fontSize: "14px",
            }}
          >
            FREE TOOLS
          </span>
          <h2
            className="tc-primary head-font mb-4"
            style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)" }}
          >
            Should You Build Custom or Buy Off-the-Shelf?
          </h2>
          <p
            className="head-font2 tc-primary fs-18 mx-auto"
            style={{ maxWidth: "700px", color: "#0A2458" }}
          >
            Not sure if custom software is right for your business? Use our{" "}
            <strong>free interactive tools</strong> to find out:
          </p>
        </div>

        <div className="row g-4">
          {tools.map((tool, index) => (
            <div className="col-lg-4" key={index}>
              <div
                className="h-100 p-4 rounded-4 position-relative"
                style={{
                  background: "white",
                  border: "1px solid rgba(10, 36, 88, 0.1)",
                  boxShadow: "0 10px 30px rgba(10, 36, 88, 0.08)",
                  transition: "all 0.4s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-10px)";
                  e.currentTarget.style.boxShadow =
                    "0 20px 40px rgba(10, 36, 88, 0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "0 10px 30px rgba(10, 36, 88, 0.08)";
                }}
              >
                <div
                  className="mb-4 rounded-3 d-inline-flex align-items-center justify-content-center"
                  style={{
                    fontSize: "48px",
                    width: "80px",
                    height: "80px",
                    background: "rgba(10, 36, 88, 0.05)",
                  }}
                >
                  {tool.icon}
                </div>
                <h3 className="tc-primary head-font fs-22 mb-3">
                  {tool.title}
                </h3>
                <p
                  className="head-font2 tc-primary fs-16 mb-4"
                  style={{ color: "#0A2458" }}
                >
                  {tool.description}
                </p>
                <button
                  onClick={() => window.open(tool.link, "_blank")}
                  className="btn w-100 py-3"
                  style={{
                    background:
                      "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)",
                    border: "none",
                    color: "white",
                    fontWeight: "600",
                    borderRadius: "8px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "translateY(-2px)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "translateY(0)";
                  }}
                >
                  {tool.title === "ROI Calculator"
                    ? "Calculate Now →"
                    : tool.title === "Decision Matrix"
                      ? "Take Assessment →"
                      : tool.title === "Custom Software Total Cost Calculator"
                        ? "Calculate Total Cost →"
                        : tool.title ===
                            "Custom Software Success Metrics Tracker"
                          ? "Get Success Matrix →"
                          : tool.title ===
                              "5 Signs You Need Custom Business Software"
                            ? "View Signs →"
                            : "Analyze Costs →"}
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-5">
          <div
            className="d-inline-flex align-items-center gap-2 p-3 rounded-3"
            style={{ background: "rgba(255, 255, 255, 0.5)" }}
          >
            <div style={{ fontSize: "20px" }}>🔒</div>
            <p
              className="head-font2 black fs-16 mb-0"
              style={{ fontStyle: "italic" }}
            >
              No email required. No sales pressure. Just honest insights.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

// INDUSTRIES SECTION
const IndustriesSection = () => {
  const industries = [
    {
      icon: "🏭",
      name: "Manufacturing",
      description: "Production tracking, inventory, quality control",
    },
    {
      icon: "🏥",
      name: "Healthcare",
      description: "Patient management, scheduling, compliance",
    },
    {
      icon: "📦",
      name: "Logistics",
      description: "Fleet management, route optimization, tracking",
    },
    {
      icon: "🏪",
      name: "Retail",
      description: "POS systems, inventory, customer management",
    },
    {
      icon: "💼",
      name: "Professional Services",
      description: "Project management, billing, client portals",
    },
    {
      icon: "📊",
      name: "Finance",
      description: "Custom reporting, data analysis, automation",
    },
    {
      icon: "🏢",
      name: "Real Estate",
      description: "Property management, CRM, analytics",
    },
    {
      icon: "🎓",
      name: "Education",
      description: "Learning management, administration, portals",
    },
    {
      icon: "⚖️",
      name: "Legal Services",
      description: "Case management, compliance tracking, document automation",
    },
  ];

  return (
    <section
      className="sec-07"
      style={{
        padding: "100px 0",
        background: "linear-gradient(180deg, #FFFFFF 0%, #F8FAFF 100%)",
      }}
    >
      <div className="container">
        <div className="text-center mb-5">
          <span
            className="px-3 py-1 rounded-pill d-inline-block mb-3"
            style={{
              background: "rgba(10, 36, 88, 0.1)",
              color: "#0a2458",
              fontWeight: "600",
              fontSize: "14px",
            }}
          >
            INDUSTRIES WE SERVE
          </span>
          <h2
            className="tc-primary head-font mb-4"
            style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)" }}
          >
            Custom Solutions for Every Industry
          </h2>
          <p
            className="head-font2 tc-primary fs-18"
            style={{ maxWidth: "600px", margin: "0 auto", color: "#0A2458" }}
          >
            Every industry has unique challenges. <br />
            We've built custom software for diverse sectors:
          </p>
        </div>

        <div className="row g-4">
          {industries.map((industry, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div
                className="p-4 rounded-4 h-100"
                style={{
                  background: "white",
                  border: "1px solid rgba(10, 36, 88, 0.1)",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.background = "rgba(10, 36, 88, 0.02)";
                  e.currentTarget.style.borderColor = "#0a2458";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.background = "white";
                  e.currentTarget.style.borderColor = "rgba(10, 36, 88, 0.1)";
                }}
              >
                <div className="d-flex align-items-center gap-3">
                  <div
                    className="flex-shrink-0 rounded-3 d-flex align-items-center justify-content-center"
                    style={{
                      fontSize: "32px",
                      width: "60px",
                      height: "60px",
                      background: "rgba(10, 36, 88, 0.05)",
                    }}
                  >
                    {industry.icon}
                  </div>
                  <div>
                    <h3 className="tc-primary head-font fs-18 mb-1">
                      {industry.name}
                    </h3>
                    <p
                      className="head-font2 tc-primary fs-15 mb-0"
                      style={{ color: "#0A2458" }}
                    >
                      {industry.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-5">
          <p
            className="head-font2 tc-primary fs-17 mb-4"
            style={{ color: "#0A2458" }}
          >
            Your industry not listed? We adapt to any business model.
          </p>
          <button
            onClick={() =>
              window.open("https://topmate.io/pluralcode/1677497", "_blank")
            }
            className="btn btn-lg px-5 py-3"
            style={{
              background: "transparent",
              border: "2px solid #0a2458",
              color: "#0a2458",
              fontWeight: "600",
              borderRadius: "50px",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "#0a2458";
              e.target.style.color = "white";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "transparent";
              e.target.style.color = "#0a2458";
            }}
          >
            Discuss Your Needs →
          </button>
        </div>
      </div>
    </section>
  );
};

// OUR SERVICES SECTION
const OurServicesSection = () => {
  const services = [
    {
      icon: "🏢",
      title: "Custom Business Software",
      description:
        "Tailored enterprise solutions built around your unique workflows and processes",
      features: [
        "Process management systems",
        "Inventory & supply chain solutions",
        "Custom CRM & ERP systems",
        "Workflow automation tools",
        "Business intelligence dashboards",
      ],
      highlighted: true,
      link: "/services/custom-business-software",
    },
    {
      icon: "🌐",
      title: "Custom Web Applications",
      description:
        "Powerful web-based platforms that work seamlessly across all devices",
      features: [
        "SaaS platforms",
        "Customer portals",
        "Admin dashboards",
        "B2B/B2C web apps",
        "Progressive Web Apps (PWA)",
      ],
      link: "/services/web-application-development",
    },
    {
      icon: "📱",
      title: "Custom Mobile Applications",
      description:
        "Native and cross-platform mobile applications for iOS and Android",
      features: [
        "Business productivity apps",
        "Customer-facing mobile apps",
        "Field service applications",
        "IoT-connected apps",
        "Hybrid & Native solutions",
      ],
      link: "services/mobile-application-development",
    },
    {
      icon: "🛠️",
      title: "Support & Maintenance",
      description:
        "Your software evolves with your business we're here for the long run",
      features: [
        "Bug fixes & updates",
        "Feature enhancements",
        "Performance optimization",
        "Security patches",
        "Technical support",
      ],
      link: "/services/support-and-maintenance",
    },
  ];

  return (
    <section
      className="sec-08"
      id="services"
      style={{ padding: "100px 0", background: "#FFFFFF" }}
    >
      <div className="container">
        <div className="text-center mb-5">
          <span
            className="px-3 py-1 rounded-pill d-inline-block mb-3"
            style={{
              background: "rgba(255, 215, 0, 0.15)",
              color: "#0a2458",
              fontWeight: "600",
              fontSize: "14px",
            }}
          >
            OUR SERVICES
          </span>
          <h2
            className="tc-primary head-font mb-4"
            style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)" }}
          >
            Complete Custom Software Development Services
          </h2>
          <p
            className="head-font2 tc-primary fs-18 mx-auto"
            style={{ maxWidth: "700px", color: "#0A2458" }}
          >
            From initial concept to ongoing support, we build  <br/> digital solutions
            tailored to your business needs.
          </p>
        </div>

        <div className="row g-4">
          {services.map((service, index) => (
            <div className="col-lg-6" key={index}>
              <div
                className="h-100 p-4 rounded-4 position-relative"
                style={{
                  border: service.highlighted
                    ? "2px solid #0a2458"
                    : "1px solid rgba(10, 36, 88, 0.1)",
                  background: service.highlighted
                    ? "linear-gradient(135deg, #F8FAFF 0%, #F0F7FF 100%)"
                    : "white",
                  boxShadow: service.highlighted
                    ? "0 15px 35px rgba(10, 36, 88, 0.1)"
                    : "0 5px 15px rgba(10, 36, 88, 0.05)",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-5px)";
                  e.currentTarget.style.boxShadow =
                    "0 20px 40px rgba(10, 36, 88, 0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = service.highlighted
                    ? "0 15px 35px rgba(10, 36, 88, 0.1)"
                    : "0 5px 15px rgba(10, 36, 88, 0.05)";
                }}
              >
                {service.highlighted && (
                  <div
                    style={{
                      position: "absolute",
                      top: "-12px",
                      right: "20px",
                      background: "#0a2458",
                      color: "white",
                      padding: "6px 20px",
                      borderRadius: "20px",
                      fontSize: "12px",
                      fontWeight: "600",
                      zIndex: 1,
                    }}
                  >
                    MOST POPULAR
                  </div>
                )}

                <div className="d-flex align-items-center gap-3 mb-4">
                  <div
                    className="flex-shrink-0 rounded-3 d-flex align-items-center justify-content-center"
                    style={{
                      fontSize: "32px",
                      width: "60px",
                      height: "60px",
                      background: "rgba(10, 36, 88, 0.1)",
                    }}
                  >
                    {service.icon}
                  </div>
                  <div>
                    <h3 className="tc-primary head-font fs-20 mb-1">
                      {service.title}
                    </h3>
                    <p
                      className="head-font2 tc-primary fs-14 mb-0"
                      style={{ color: "#0A2458" }}
                    >
                      {service.description}
                    </p>
                  </div>
                </div>

                <div className="mb-4">
                  <p
                    className="head-font2 tc-primary fs-15 fw-bold mb-2"
                    style={{ color: "#0a2458" }}
                  >
                    What we provide:
                  </p>
                  <div className="row g-2">
                    {service.features.map((feature, idx) => (
                      <div className="col-6" key={idx}>
                        <div className="d-flex align-items-center gap-2">
                          <div style={{ fontSize: "12px", color: "#0a2458" }}>
                            ✓
                          </div>
                          <p
                            className="head-font2 tc-primary fs-14 mb-0"
                            style={{ color: "#0A2458" }}
                          >
                            {feature}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <button
                  onClick={() => window.open(service.link, "_blank")}
                  className="btn w-100 py-3"
                  style={{
                    background: service.highlighted
                      ? "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)"
                      : "transparent",
                    border: service.highlighted ? "none" : "1px solid #0a2458",
                    color: service.highlighted ? "white" : "#0a2458",
                    fontWeight: "600",
                    borderRadius: "8px",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    if (!service.highlighted) {
                      e.target.style.background = "#0a2458";
                      e.target.style.color = "white";
                    } else {
                      e.target.style.transform = "translateY(-2px)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!service.highlighted) {
                      e.target.style.background = "transparent";
                      e.target.style.color = "#0a2458";
                    } else {
                      e.target.style.transform = "translateY(0)";
                    }
                  }}
                >
                  {service.title.includes("Business")
                    ? "Learn More →"
                    : service.title.includes("Web")
                      ? "Explore Web Apps →"
                      : service.title.includes("Mobile")
                        ? "See Mobile Solutions →"
                        : "Support Plans →"}
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-5">
          <div
            className="p-5 rounded-4"
            style={{
              background:
                "linear-gradient(135deg, rgba(10, 36, 88, 0.03) 0%, rgba(10, 36, 88, 0.01) 100%)",
              border: "1px solid rgba(10, 36, 88, 0.1)",
            }}
          >
            <div className="d-flex align-items-center justify-content-center gap-3 mb-3">
              <div style={{ fontSize: "32px" }}>💡</div>
              <h3 className="tc-primary head-font fs-20 mb-0">
                <strong>Not sure what you need?</strong>
              </h3>
            </div>
            <p
              className="head-font2 tc-primary fs-16 mb-4 mx-auto"
              style={{ maxWidth: "600px", color: "#0A2458" }}
            >
              Start with our free consultation. We'll help you identify the
              right solution <br/> for your business challenges.
            </p>
            <button
              onClick={() =>
                window.open("https://topmate.io/pluralcode/1677497", "_blank")
              }
              className="btn btn-lg px-5 py-3"
              style={{
                background: "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)",
                border: "none",
                color: "white",
                fontWeight: "600",
                borderRadius: "50px",
                boxShadow: "0 10px 25px rgba(10, 36, 88, 0.2)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 15px 30px rgba(10, 36, 88, 0.3)";
              }}
              onMouseLeave={(e) => {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 10px 25px rgba(10, 36, 88, 0.2)";
              }}
            >
              Get Expert Guidance →
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

// TECHNOLOGIES SECTION
const TechnologiesSection = () => {
  const technologies = [
    { src: images?.rorTechnology, alt: "Ruby on Rails", width: 125 },
    { src: images?.flutter, alt: "Flutter", width: 70 },
    { src: images?.django, alt: "Django", width: 90 },
    { src: images?.expressjs, alt: "Express.js", width: 90 },
    { src: images?.reactTechnology, alt: "React", width: 225 },
    { src: images?.reactnativeTechnology, alt: "React Native", width: 225 },
  ];

  return (
    <section
      style={{
        padding: "80px 0",
        background: "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)",
      }}
    >
      <div className="container">
        <div className="text-center mb-5">
          <span
            className="px-3 py-1 rounded-pill d-inline-block mb-3"
            style={{
              background: "rgba(255, 255, 255, 0.15)",
              color: "white",
              fontWeight: "600",
              fontSize: "14px",
              backdropFilter: "blur(10px)",
            }}
          >
            TECHNOLOGY STACK
          </span>
          <h2
            className="head-font mb-4"
            style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)", color: "white" }}
          >
            Built with Modern, Proven Technologies
          </h2>
          <p
            className="head-font2 fs-18 mx-auto"
            style={{ maxWidth: "600px", color: "rgba(255, 255, 255, 0.8)" }}
          >
            We use industry-leading technologies to build <br /> robust,
            scalable, and maintainable solutions
          </p>
        </div>

        <div className="row g-4 justify-content-center align-items-center">
          {technologies.map((tech, index) => (
            <div className="col-lg-2 col-md-4 col-6" key={index}>
              <div
                className="d-flex align-items-center justify-content-center p-4 rounded-3"
                style={{
                  background: "rgba(255, 255, 255, 0.05)",
                  border: "1px solid rgba(255, 255, 255, 0.1)",
                  height: "120px",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
                  e.currentTarget.style.transform = "translateY(-5px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background =
                    "rgba(255, 255, 255, 0.05)";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <img
                  src={tech.src}
                  style={{
                    height: "auto",
                    width: tech.width ? `${tech.width}px` : "auto",
                    maxWidth: "100%",
                    filter: "brightness(0) invert(1)",
                  }}
                  className="img-fluid"
                  alt={tech.alt}
                />
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-5">
          <div
            className="d-inline-flex align-items-center gap-3 p-4 rounded-3"
            style={{
              background: "rgba(255, 255, 255, 0.05)",
              border: "1px solid rgba(255, 255, 255, 0.1)",
            }}
          >
            <div style={{ fontSize: "24px", color: "#FFD700" }}>🔄</div>
            <div className="text-start">
              <p
                className="head-font2 fs-17 mb-0"
                style={{ color: "rgba(255, 255, 255, 0.9)" }}
              >
                <strong>Full-stack expertise</strong> - From backend APIs to
                modern frontend interfaces
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// WHY CHOOSE US SECTION
const WhyChooseUsSection = () => {
  const benefits = [
    {
      icon: "🎯",
      title: "Extreme Customization",
      description:
        "Not templates. Not configurations. True custom development built from scratch for your workflow.",
    },
    {
      icon: "💬",
      title: "Transparent Communication",
      description:
        "Weekly updates, open Slack channels, complete visibility into development progress.",
    },
    {
      icon: "🧠",
      title: "Business-First Thinking",
      description:
        "We're not just coders. We understand business processes and solve problems strategically.",
    },
    {
      icon: "⚡",
      title: "Agile & Adaptive",
      description:
        "Requirements change? No problem. Our process embraces evolution and feedback.",
    },
    {
      icon: "🔒",
      title: "You Own Everything",
      description:
        "Complete code ownership, documentation, and intellectual property rights no vendor lock-in.",
    },
    {
      icon: "🌏",
      title: "International Experience",
      description:
        "Working with businesses across US, Australia, New Zealand, Singapore, and Canada.",
    },
  ];

  return (
    <section
      className="sec-09"
      style={{ padding: "100px 0", background: "#FFFFFF" }}
    >
      <div className="container">
        <div className="text-center mb-5">
          <span
            className="px-3 py-1 rounded-pill d-inline-block mb-3"
            style={{
              background: "rgba(10, 36, 88, 0.1)",
              color: "#0a2458",
              fontWeight: "600",
              fontSize: "14px",
            }}
          >
            WHY CHOOSE US
          </span>
          <h2
            className="tc-primary head-font mb-4"
            style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)" }}
          >
            Why Businesses Choose Custom Development with Us
          </h2>
          <p
            className="head-font2 tc-primary fs-18 mx-auto"
            style={{ maxWidth: "600px", color: "#0A2458" }}
          >
            Discover what sets us apart in delivering exceptional custom
            software solutions
          </p>
        </div>

        <div className="row g-4">
          {benefits.map((benefit, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div
                className="h-100 p-4 text-center rounded-4"
                style={{
                  background: "rgba(10, 36, 88, 0.02)",
                  border: "1px solid rgba(10, 36, 88, 0.05)",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "rgba(10, 36, 88, 0.05)";
                  e.currentTarget.style.transform = "translateY(-5px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "rgba(10, 36, 88, 0.02)";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <div
                  className="mx-auto mb-4 rounded-3 d-flex align-items-center justify-content-center"
                  style={{
                    fontSize: "40px",
                    width: "80px",
                    height: "80px",
                    background: "rgba(10, 36, 88, 0.1)",
                  }}
                >
                  {benefit.icon}
                </div>
                <h3 className="tc-primary head-font fs-18 mb-3">
                  {benefit.title}
                </h3>
                <p
                  className="head-font2 tc-primary fs-16 mb-0"
                  style={{ color: "#0A2458" }}
                >
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* <div className="text-center mt-5">
          <div
            className="d-inline-flex align-items-center justify-content-center gap-4 p-4 rounded-4"
            style={{
              background:
                "linear-gradient(135deg, rgb(10, 36, 88) 0%, rgb(26, 59, 138) 100%)",
            }}
          >
            <div className="text-center">
              <div
                className="head-font fs-32 fw-bold"
                style={{ color: "white" }}
              >
                98%
              </div>
              <div className="head-font2 fs-14" style={{ color: "white" }}>
                Client Retention
              </div>
            </div>
            <div className="text-center">
              <div
                className="head-font fs-32 fw-bold"
                style={{ color: "white" }}
              >
                4.9/5
              </div>
              <div className="head-font2 fs-14" style={{ color: "white" }}>
                Satisfaction Rating
              </div>
            </div>
            <div className="text-center">
              <div
                className="head-font fs-32 fw-bold"
                style={{ color: "white" }}
              >
                24/7
              </div>
              <div className="head-font2 fs-14" style={{ color: "white" }}>
                Support Available
              </div>
            </div>
          </div>
        </div> */}

        <div className="text-center mt-5">
  <div
    className="d-flex align-items-center justify-content-between gap-4 p-5 rounded-4 mx-auto"
    style={{
      background:
        "linear-gradient(135deg, rgb(10, 36, 88) 0%, rgb(26, 59, 138) 100%)",
      maxWidth: "800px",
      width: "100%",
    }}
  >
    <div className="text-center flex-fill">
      <div className="head-font fs-32 fw-bold" style={{ color: "#ffd700" }}>
        98%
      </div>
      <div className="head-font2 fs-25" style={{ color: "#ffd700" }}>
        Client Retention
      </div>
    </div>

    <div className="text-center flex-fill">
      <div className="head-font fs-32 fw-bold" style={{ color: "#ffd700" }}>
        4.9/5
      </div>
      <div className="head-font2 fs-25" style={{ color: "#ffd700" }}>
        Satisfaction Rating
      </div>
    </div>

    <div className="text-center flex-fill">
      <div className="head-font fs-32 fw-bold" style={{ color: "#ffd700" }}>
        24/7
      </div>
      <div className="head-font2 fs-25" style={{ color: "#ffd700" }}>
        Support Available
      </div>
    </div>
  </div>
</div>

      </div>
    </section>
  );
};

// CLIENTS SECTION
const ClientsSection = () => {
  return (
    <section
      style={{
        padding: "100px 0",
        background: "linear-gradient(180deg, #F8FAFF 0%, #FFFFFF 100%)",
      }}
    >
      <div className="container">
        <div className="text-center mb-5">
          <span
            className="px-3 py-1 rounded-pill d-inline-block mb-3"
            style={{
              background: "rgba(10, 36, 88, 0.1)",
              color: "#0a2458",
              fontWeight: "600",
              fontSize: "14px",
            }}
          >
            OUR CLIENTS
          </span>
          <h2
            className="tc-primary head-font mb-4"
            style={{ fontSize: "clamp(2rem, 4vw, 2.75rem)" }}
          >
            Trusted by Growing Businesses Worldwide
          </h2>
          <p
            className="head-font2 tc-primary fs-18 mx-auto"
            style={{ maxWidth: "600px" }}
          >
            Join hundreds of satisfied clients who transformed <br /> their
            businesses with our custom solutions
          </p>
        </div>

        {/* <div className="row g-4 mb-5">
          {PORTFOLIOS.slice(0, 8).map(
            (item) =>
              item?.forHomePage && <ClientCard item={item} key={item.name} />
          )}
        </div> */}

        <div className="row g-4">
          {PORTFOLIOS.filter((item) => item?.forHomePage)
            .slice(0, 8)
            .map((item) => (
              <div className="col-lg-3 col-md-3 col-sm-6" key={item.name}>
                <ClientCard item={item} />
              </div>
            ))}
        </div>

        {/* <div className="row g-4">
          {PORTFOLIOS.slice(8, 23).map(
            (item) =>
              item?.forHomePage && <ClientCard item={item} key={item.name} />
          )}
        </div> */}

        {/* <div className="text-center mt-5">
          <button
            onClick={() => window.open("/portfolio", "_blank")}
            className="btn btn-lg px-5 py-3"
            style={{
              background: "transparent",
              border: "2px solid #0a2458",
              color: "#0a2458",
              fontWeight: "600",
              borderRadius: "50px",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.background = "#0a2458";
              e.target.style.color = "white";
            }}
            onMouseLeave={(e) => {
              e.target.style.background = "transparent";
              e.target.style.color = "#0a2458";
            }}
          >
            View All Case Studies →
          </button>
        </div> */}
      </div>
    </section>
  );
};

// FINAL CTA SECTION
const FinalCTASection = () => {
  return (
    <section
      className="sec-10"
      style={{
        padding: "100px 0",
        background: "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Background pattern */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `radial-gradient(circle at 25% 25%, rgba(255, 215, 0, 0.1) 2px, transparent 2px)`,
          backgroundSize: "40px 40px",
        }}
      />

      <div className="container position-relative" style={{ zIndex: 1 }}>
        <div className="text-center mb-5">
          <span
            className="px-3 py-1 rounded-pill d-inline-block mb-3"
            style={{
              background: "rgba(255, 255, 255, 0.15)",
              color: "white",
              fontWeight: "600",
              fontSize: "14px",
              backdropFilter: "blur(10px)",
            }}
          >
            GET STARTED
          </span>
          <h2 className="head-font fs-44 mb-4" style={{ color: "white" }}>
            Ready to Build Software That Actually Fits?
          </h2>
          <p
            className="head-font2 fs-20 mb-5 mx-auto"
            style={{
              color: "rgba(255, 255, 255, 0.9)",
              maxWidth: "700px",
            }}
          >
            Let's discuss your unique challenges and explore whether custom
            development is right for you.
          </p>
        </div>

        <div className="row g-4 justify-content-center">
          <div className="col-lg-5 col-md-6">
            <div
              className="p-4 h-100 rounded-4"
              style={{
                background: "rgba(255, 255, 255, 0.95)",
                backdropFilter: "blur(10px)",
                boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
              }}
            >
              <div className="d-flex align-items-center gap-3 mb-4">
                <div
                  className="flex-shrink-0 rounded-3 d-flex align-items-center justify-content-center"
                  style={{
                    fontSize: "32px",
                    width: "60px",
                    height: "60px",
                    background: "rgba(10, 36, 88, 0.1)",
                  }}
                >
                  📊
                </div>
                <h3 className="tc-primary head-font fs-20 mb-0">
                  Free Assessment Tools
                </h3>
              </div>
              <p
                className="head-font2 tc-primary fs-16 mb-4"
                style={{ color: "#0A2458" }}
              >
                Not ready to talk? Start with data-driven insights:
              </p>
              <ul className="mb-4">
                {[
                  "ROI Calculator",
                  "Decision Matrix",
                  "Requirements Worksheet",
                  "High-level feasibility & cost insights",
                ].map((item, index) => (
                  <li
                    key={index}
                    className="d-flex align-items-center gap-2 mb-2"
                  >
                    <div
                      style={{
                        width: "8px",
                        height: "8px",
                        background: "#0a2458",
                        borderRadius: "50%",
                      }}
                    ></div>
                    <p
                      className="head-font2 tc-primary fs-15 mb-0"
                      style={{ color: "#0A2458" }}
                    >
                      {item}
                    </p>
                  </li>
                ))}
              </ul>
              <button
                onClick={() => window.open("/lm/tools", "_blank")}
                className="btn btn-lg w-100 py-3"
                style={{
                  background:
                    "linear-gradient(135deg, #0a2458 0%, #1a3b8a 100%)",
                  border: "none",
                  color: "white",
                  fontWeight: "600",
                  borderRadius: "8px",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow =
                    "0 10px 20px rgba(10, 36, 88, 0.3)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "none";
                }}
              >
                Explore Free Tools →
              </button>
            </div>
          </div>

          <div className="col-lg-5 col-md-6">
            <div
              className="p-4 h-100 rounded-4"
              style={{
                background: "rgba(255, 255, 255, 0.95)",
                backdropFilter: "blur(10px)",
                boxShadow: "0 20px 40px rgba(0,0,0,0.1)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                position: "relative",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: "-10px",
                  right: "20px",
                  background: "#FFD700",
                  color: "#0a2458",
                  padding: "5px 15px",
                  borderRadius: "20px",
                  fontSize: "12px",
                  fontWeight: "600",
                }}
              >
                MOST POPULAR
              </div>

              <div className="d-flex align-items-center gap-3 mb-4">
                <div
                  className="flex-shrink-0 rounded-3 d-flex align-items-center justify-content-center"
                  style={{
                    fontSize: "32px",
                    width: "60px",
                    height: "60px",
                    background: "rgba(10, 36, 88, 0.1)",
                  }}
                >
                  💬
                </div>
                <h3 className="tc-primary head-font fs-20 mb-0">
                  Free Consultation
                </h3>
              </div>
              <p
                className="head-font2 tc-primary fs-16 mb-4"
                style={{ color: "#0A2458" }}
              >
                30-minute strategy call to discuss:
              </p>
              <ul className="mb-4">
                {[
                  "Your current challenges & goals",
                  "Workflow & process analysis",
                  "Potential solutions & approach",
                  "Ballpark timeline & investment",
                ].map((item, index) => (
                  <li
                    key={index}
                    className="d-flex align-items-center gap-2 mb-2"
                  >
                    {/* <div style={{ color: "#0a2458", fontSize: "20px" }}>→</div> */}
                    <div
                      style={{
                        width: "8px",
                        height: "8px",
                        background: "#0a2458",
                        borderRadius: "50%",
                      }}
                    ></div>
                    <p
                      className="head-font2 tc-primary fs-15 mb-0"
                      style={{ color: "#0A2458" }}
                    >
                      {item}
                    </p>
                  </li>
                ))}
              </ul>
              <button
                onClick={() =>
                  window.open("https://topmate.io/pluralcode/1677497", "_blank")
                }
                className="btn btn-lg w-100 py-3"
                style={{
                  background:
                    "linear-gradient(135deg, #FFD700 0%, #FFC107 100%)",
                  border: "none",
                  color: "#0a2458",
                  fontWeight: "600",
                  borderRadius: "8px",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow =
                    "0 10px 20px rgba(255, 215, 0, 0.3)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "none";
                }}
              >
                Schedule Consultation →
              </button>
            </div>
          </div>
        </div>

        <div className="text-center mt-5 pt-5">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div
                className="p-4 rounded-4"
                style={{
                  background: "rgba(255, 255, 255, 0.1)",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  backdropFilter: "blur(10px)",
                }}
              >
                <div className="row g-4">
                  <div className="col-md-4">
                    <div className="text-center">
                      <div
                        className="head-font2 fs-17 mb-1"
                        style={{ color: "rgba(255, 255, 255, 0.8)" }}
                      >
                        Email
                      </div>
                      <div
                        className="head-font2 fs-17 fw-bold"
                        style={{ color: "white" }}
                      >
                        info@pluralcode.com
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="text-center">
                      <div
                        className="head-font2 fs-17 mb-1"
                        style={{ color: "rgba(255, 255, 255, 0.8)" }}
                      >
                        Call
                      </div>
                      <div
                        className="head-font2 fs-17 fw-bold"
                        style={{ color: "white" }}
                      >
                        +91 9958920231
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="text-center">
                      <div
                        className="head-font2 fs-17 mb-1"
                        style={{ color: "rgba(255, 255, 255, 0.8)" }}
                      >
                        Response Time
                      </div>
                      <div
                        className="head-font2 fs-17 fw-bold"
                        style={{ color: "#FFD700" }}
                      >
                        Within 2 Hours
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <p
                className="head-font2 fs-17 mt-4 mb-0"
                style={{ color: "rgba(255, 255, 255, 0.9)" }}
              >
                Trusted by businesses of all sizes and industries around the
                world.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// MAIN HOME COMPONENT
export default function Home() {
  const { showModal, handleClose } = useModal();

  useEffect(() => {
    document.title =
      "Custom Business Software Development | Plural Code Technologies";

    // Add smooth scrolling for anchor links
    const handleAnchorClick = (e) => {
      const target = e.target.closest('a[href^="#"]');
      if (target) {
        e.preventDefault();
        const id = target.getAttribute("href").slice(1);
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    };

    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);

  return (
    <div>
      <main className="wrapper">
        <HeroSection />
        <ProblemSection />
        <SolutionSection />
        <HowItWorksSection />
        <ProofSection />
        <LeadMagnetSection />
        <IndustriesSection />
        <OurServicesSection />
        <TechnologiesSection />
        <WhyChooseUsSection />
        <ClientsSection />
        <FinalCTASection />
      </main>

      {/* {showModal && (
        <SoftwareAuditModal handleClose={handleClose} showModal={showModal} />
      )} */}
    </div>
  );
}
